module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "group group--narrow-f2f"
  }, [_c('h1', {
    staticClass: "h1 group__title mw600",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("\n      How would you like to\n      "), _c('br', {
    staticClass: "hide-below-small"
  }), _vm._v("talk to your counselor?\n    ")]), _vm._v(" "), _c('ul', {
    staticClass: "appointment-type-list appointment-type-list--f2f"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "appointment-type-list__item appointment-type-list__item--border mb",
      on: {
        "click": function($event) {
          return _vm.select(item.target)
        }
      }
    }, [_c('div', {
      staticClass: "appointment-type-list__content appointment-type-list__content--flex"
    }, [_c('h2', {
      staticClass: "h2 mt0 mb-",
      style: ({
        'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
      })
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('ul', [_vm._l((item.listItems), function(listItem, index) {
      return _c('li', {
        key: index,
        staticClass: "c-accent fw-medium",
        style: ({
          'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
        }),
        domProps: {
          "innerHTML": _vm._s(listItem)
        }
      })
    }), _vm._v(" "), (item.target === "results") ? _c('p', {
      staticClass: "mt- mb0 p fs-14 fw-medium appointment-type__info"
    }, [_vm._v("\n              Currently available for individual counseling. For family or couples counseling options, please contact us at " + _vm._s(_vm.formattedNumber) + "\n            ")]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
      staticClass: "appointment-type-list__content appointment-type-list__content--image pa0 hide-below-medium"
    }, [_c('div', {
      class: ["appointment-type-list__image", ("appointment-type-list__image--" + (item.image))]
    })])])
  }), 0), _vm._v(" "), _c('p', {
    staticClass: "p fs-14"
  }, [_vm._v("*For video chat, you will need a computer, tablet, or mobile phone with a camera. To speak over the phone, we’ll give you a call.")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43cf91b4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/appointment/AppointmentType.vue
// module id = 466
// module chunks = 0